import type {
  RecoverPrivacyFundsRequest,
  RecoverPrivacyFundsResponse,
} from '@polaris/core/services'
import { runnerSessionDataAtom } from '@polaris/core/stores/mpc/atom'
import { useMutation } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import { recoverPrivacyFunds } from '@/src/services/mpc'
import {
  type ParsedMpcError,
  parseMpcError,
} from '@/src/utils/parse-mpc-errors'

export const useMpcRecoverPrivacyFunds = () => {
  const mpcSessionData = useAtomValue(runnerSessionDataAtom)

  return useMutation<
    RecoverPrivacyFundsResponse,
    ParsedMpcError,
    Omit<RecoverPrivacyFundsRequest, 'sessionKeyData'>
  >({
    mutationKey: ['mpc-recover-privacy-funds'],
    mutationFn: async (
      payload: Omit<RecoverPrivacyFundsRequest, 'sessionKeyData'>,
    ) => {
      try {
        const result = await recoverPrivacyFunds({
          ...payload,
          sessionKeyData: {
            walletSig: mpcSessionData!.authSig,
            sessionKeyPair: mpcSessionData!.sessionKeyPair,
          },
        })
        return result
      } catch (error) {
        throw parseMpcError(error)
      }
    },
  })
}
